import { useLocation } from "react-router-dom";
import { useStickyNotificationsStore } from "../providers/UseStickyNotificationHookProvider";
import { useEffect } from "react";

/**
 * Whenever the route changes, this hook runs. At the moment, it is only being used
 * to clear page-scoped stickyNotifications which are set via useStickyNotifs hook.
 */
export const useOnRouteChange = () => {
  const { pathname } = useLocation();
  const { removePageScopedMessages } = useStickyNotificationsStore();

  // We need the useEffect to listen to navigation changes
  useEffect(() => {
    removePageScopedMessages();
  }, [pathname, removePageScopedMessages]);
};
